module.exports = __webpack_public_path__ + "7e456a9299cc32f5b509b9dc0bc330ab.svg";